<!-- eslint-disable max-len -->
<template>
  <div class="about-orgs_aor" :class="{ [curTheme]: true }">

    <page-header>
      <h1>Вузы-участники проекта</h1>
    </page-header>

    <page-text>
      <div class="aor_items">
        <div
          v-for="(v, i) in items"
          :key="`item-${i}`"
          @click="showDialog(v)"
          class="aor_item">
          <img
            class="aor_hex"
            src="/static/grx/hex/white-shadow.png">
          <img
            :src="`/static/data/orgs/logos-fixed-wh/${v.id}.png`"
            class="aor_image">
          <el-tooltip
            :content="tooltip(v)"
            v-if="v.icons"
            placement="top"
            :enterable="false"
            :open-delay="500">
            <div
              class="aor_icons">
              <img
                  v-for="(ic, j) in v.icons"
                  :key="`item-${i}-icon-${j}`"
                  :src="`/static/data/orgs/icons/${ic}.png`">
            </div>
          </el-tooltip>

        </div>
      </div>

      <el-dialog
          v-if="curItem"
          class="aor_dialog_aod"
          :visible.sync="dialogVisible">
        <div class="aod_desc">
          <h3><a :href="curItem.site" target="_blank" class="aod_title">{{ curItem.title }}</a></h3>
          <a :href="curItem.site" target="_blank">
            <img
              class="aod_image"
              :class="`apd_${curItem.id}`"
              :src="`/static/data/orgs/logos-fixed-w/${curItem.id}.png`">
          </a>
          <div v-html="curItem.desc"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
              class="vivid-button"
              @click="dialogVisible = false">
            Закрыть
          </el-button>
        </span>
      </el-dialog>

    </page-text>

    <page-footer/>
  </div>
</template>

<script>
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {

  components: { PageHeader, PageText, PageFooter },

  data() {
    return {
      dialogVisible: false,
      curItem: null,
      items: [
        {
          id: 'bsu',
          title: 'Белгородский государственный национальный исследовательский университет, НИУ БелГУ',
          site: 'https://www.bsu.edu.ru/bsu/',
          desc: '<p>Один из старейших вузов Белгорода, крупнейший научно-образовательный и культурный центр Белгородской области, входит в Ассоциацию ведущих вузов России и в двадцатку лучших вузов страны по оценке Министерства образования и науки. В НИУ «БелГУ» обучается более 23 тысяч студентов из всех регионов России и 91 страны мира. Свыше 2800 студентов — иностранные граждане.</p><p>НИУ «БелГУ» входит и консорциум ведущих вузов страны, продвигающих российское образование за рубежом, является базовым вузом сетевого Университета ШОС по пяти направлениям.</p>',
          icons: ['registry'],
        },
        {
          id: 'dvfu',
          title: 'Дальневосточный федеральный университет, ДВФУ',
          site: 'https://www.dvfu.ru/',
          desc: '<p>Уникальное геополитическое расположение ДВФУ обеспечивает роль ведущего российского центра образования и науки на Дальнем Востоке как связующего и коммуникационного звена между двумя крупными развивающимися рынками – России и Азиатско-Тихоокеанского региона (АТР). Это возможно благодаря узнаваемости и устойчивым академическим связям с ведущими университетами АТР, которые в том числе обеспечиваются членством ДВФУ (единственный вуз России) в Ассоциации ведущих вузов АТР (APRU – Association of Pacific-Rim Universities).</p><p>Университет предоставляет уникальную инфраструктуру единого кампуса, включающую, помимо современной базы для научно-образовательной и инновационной деятельности, также конгресс-центр, высокотехнологичный медицинский центр, гостиницы и прочее – создание комфортной среды, благоприятной для исследований и обучения, проживания и общения, всестороннего развития и творческой самореализации личности. Стратегической целью университета является создание на острове Русский международного научно-образовательного и технологического кластера мирового уровня. Миссия ДВФУ – представлять позицию страны в проектировании и воплощении глобальных стратегий решения «больших вызовов» Азиатско-Тихоокеанского региона посредством научной, образовательной и инновационной деятельности.</p>',
          icons: ['registry'],
        },
        {
          id: 'mgsu',
          title: 'Национальный исследовательский Московский государственный строительный университет, НИУ МГСУ',
          site: 'http://mgsu.ru/',
          desc: '<p>Один из ведущих технических вузов и главный инженерно-строительный университет в России, один из отраслевых вузов по программе «Стратегическое партнерство архитектурно-строительных образовательных учреждений РФ».</p><p>Лидер по подготовке специалистов для одной из самых динамично развивающихся отраслей — строительства.</p>',
          icons: ['storage', 'registry'],
        },
        {
          id: 'psu',
          title: 'Пермский государственный национальный исследовательский университет, ПГНИУ',
          site: 'http://www.psu.ru/',
          desc: '<p>Первый университет на Урале, один из учредителей Ассоциации классических университетов России и Ассоциации ведущих университетов России. Солидную базу для проведения учебных и производственных практик и научных исследований представляют Естественнонаучный институт, особое конструкторское бюро &laquo;Маяк&raquo;, Ботанический сад, учебно-научная база &laquo;Предуралье&raquo;, а также учебно-опытное лесное хозяйство &laquo;Троицкое&raquo;, расположенное в Челябинской области. Фундаментальная научная библиотека университета является одой из крупнейших в регионе. В 2006 году университет стал победителем конкурса в рамках приоритетного национального проекта &laquo;Образование&raquo;, в 2010 году ему присвоен статус национального исследовательского университета.</p><p>Международная деятельность ПГНИУ направлена на укрепление академического сотрудничества с зарубежными университетами в области совместных научных исследований, разработку учебных программ, а также обмен преподавателями, аспирантами и студентами. Особо значимые образовательные и научные связи сложились с Оксфордским, Манчестер Метрополитан университетами (Великобритания), Университетом Люнебурга (Германия),&nbsp; Словенским университетом (г. Любляна, Словения) и многими другими. Всего на данный момент заключено более 90 партнёрских соглашений с вузами разных стран, а ПГНИУ стал местом обучения почти двухсот иностранных студентов.</p><p>Пермский университет стал первым вузом в Прикамье, который стал участником академического рейтинга университетов мира Quacquarelli Symonds (QS). С 2014 году ПГНИУ входит в число лучших высших учебных заведений стран БРИКС, а также стран Восточной Европы и Центральной Азии. В этом году ПГНИУ также вошел в ТОП-10 вузов Приволжского федерального округа по показателям образовательной деятельности (рейтинг ИД &laquo;ЕвроМедиа&raquo;), в тройку лидирующих российских вузов по уровню зарплат выпускников, работающих в IT-отрасли (рейтинг Superjob).</p>',
          icons: ['registry'],
        },
        {
          id: 'ranhigs',
          title: 'Российская академия народного хозяйства и государственной службы при Президенте Российской Федерации, РАНХиГС',
          site: 'https://www.ranepa.ru/',
          desc: '<p>Крупнейший в России и Европе университет социально-экономического и гуманитарного профиля, по праву занимающий верхние строки во всех национальных рейтингах. В 2016 году Президентская академия получила статус Авторизованного экзаменационного центра Департамента экзаменов Кембриджского университета &ndash;Cambridge English Language Assessment. &nbsp; В международном реестре Академии присвоен собственный номер: RU181. Таким образом, Кембриджский университет делегировал РАНХиГС право проводить экзамены и подготовку к ним, а также присуждать семь международных сертификатов по английскому языку.</p><p>Миссией Российской академии народного хозяйства и государственной службы при Президенте Российской Федерации является: подготовка глобально конкурентоспособных и адаптивных управленческих кадров для государственного, общественного и частного секторов с целью решения задачи инновационного развития общества; осуществление фундаментальных и прикладных научных исследований и разработок в социально-экономической и гуманитарной сферах; научное и экспертно-аналитическое сопровождение органов государственной власти Российской Федерации.</p>',
          icons: ['storage', 'registry'],
        },
        {
          id: 'ssau',
          title: 'Самарский национальный исследовательский университет имени академика С.П. Королева, Самарский университет',
          site: 'https://ssau.ru',
          desc: '<p>Один из ведущих вузов России, основной научно-образовательный центр страны в сфере аэрокосмических технологий. В 2015 году он объединил коллективы аэрокосмического (СГАУ) и классического (СамГУ) университетов, став преемником их достижений и традиций. Университет непосредственно связан с промышленно-экономическим развитием Самарского региона в качестве одного из ведущих центров разработки и производства современной космической техники. В Самарском университете сформирован уникальный научно-образовательный комплекс, который обеспечивает непосредственное участие  студентов во всех этапах разработки, создания и испытания космических аппаратов, а также последующего управления ими на орбите. Научно-образовательная деятельность университета также охватывает современные методы обработки информации, фотонику, материаловедение. Помимо инженерно-технических и естественно-научных направлений, университет реализует образовательные и исследовательские программы в других областях, включая правоведение, экономику, менеджмент, лингвистику, исторические и социальные науки.</p>',
          icons: ['storage', 'registry'],
        },
        {
          id: 'spbu',
          title: 'Санкт-Петербургский государственный университет, СПбГУ',
          site: 'https://spbu.ru/',
          desc: '<p>Старейший вуз России, основанный в 1724 году. За время существования СПбГУ закрепил за собой право называться также одним из лучших вузов России: богатое историческое прошлое, современная широкая исследовательская деятельность, активное развитие и новаторство позволяют СПбГУ находиться на передовых рубежах российской науки. Университет неизменно входит в престижные международные рейтинги вузов, а также специализированные рейтинги по отраслям знаний: Quacquarelli Symonds World University Rankings by Subject, Financial Times Global Masters in Management, Financial Times European Business School Ranking. СПбГУ — единственный российский вуз в рейтинге Nature Index 2016 Rising Stars в номинации «Top 100 institutions».</p>',
          icons: ['storage', 'registry'],
        },
        {
          id: 'spbpu',
          title: 'Санкт-Петербургский политехнический университет Петра Великого, СПбПУ',
          site: 'http://www.spbstu.ru/',
          desc: '<p>Сегодня Санкт-Петербургский государственный политехнический университет – один из ведущих политехнических университетов страны, осуществляющий подготовку кадров и проведение научных исследований на мировом уровне и в интересах инновационной экономики. СПбПУ является единственным техническим университетом в Северо-Западном федеральном округе, победившим во всех мегаконкурсах по постановлениям Правительства РФ в 2007–2013 годах. Научно-образовательная структура СПбПУ включает 12 учебно-научных институтов, Объединенный научно-технологический институт, более 200 научных лабораторий и центров, более 30 НОЦ и ЦКП, более 40 малых инновационных предприятий, 32 международных НОЦ, исследовательские лаборатории и авторизованные центры обучения, тестирования и сертификации.</p>',
          icons: ['registry'],
        },
        {
          id: 'itmo',
          title: 'Санкт-Петербургский национальный исследовательский университет информационных технологий, механики и оптики, НИУ ИТМО',
          site: 'http://www.ifmo.ru/ru/',
          desc: '<p>Университет ИТМО (Санкт-Петербург) – национальный исследовательский университет, ведущий вуз России в области информационных и фотонных технологий. Альма-матер победителей международных соревнований по программированию: ACM ICPC (единственный в мире семикратный чемпион), Google Code Jam, Facebook Hacker Cup, Яндекс.Алгоритм, Russian Code Cup, Topcoder Open и др. Выпускники вуза явились создателями нового языка программирования Kotlin. Университет является обладателем медали ЮНЕСКО «За вклад в развитие нанонауки и нанотехнологий» за уникальную среду в вузе: наука–образование–инновации (2016). В 2017г. Университет ИТМО в очередной раз вошел в ТОП-100 лучших IT-вузов мира (“Computer Science”) и впервые в ТОП-400 лучших вузов мира по инженерным наукам (“Engineering and Technology”) по версии предметного рейтинга Times Higher Education. В области физических наук ("Physics & Astronomy") Университет ИТМО также  представлен в ТОП-400 по версии предметного рейтинга Quaquarelly Symonds (QS).</p>',
          icons: ['registry'],
        },
        {
          id: 'safu',
          title: 'Северный (Арктический) федеральный университет, САФУ',
          site: 'https://narfu.ru/',
          desc: '<p>Образовательная политика САФУ строится в&nbsp;соответствии Федеральной целевой программой развития образования в&nbsp;России, Стратегией развития Арктической зоны&nbsp;РФ и&nbsp;обеспечения национальной безопасности на&nbsp;период до&nbsp;2020&nbsp;года, стратегиями и&nbsp;программами развития корпораций и&nbsp;предприятий региона. Университет создаёт необходимые условия для обеспечения кадрами и&nbsp;технологическими ресурсами промышленных и&nbsp;социально- гуманитарных проектов российской Арктики. Создана и&nbsp;развивается научно-инновационная инфраструктура, включающая научно- исследовательские институты, центры коллективного пользования, научно-образовательные центры, инновационно-технологические центры и&nbsp;лаборатории, оснащенные современным оборудованием и&nbsp;укомплектованные высококвалифицированными научными кадрами.</p><p>САФУ является партнером более 130 международных организаций, сотрудничество реализуется в&nbsp;рамках 66&nbsp;партнерских соглашений с&nbsp;учебными заведениями, организациями и&nbsp;компаниями из&nbsp;29&nbsp;стран мира. Основными направлениями сотрудничества САФУ с&nbsp;вузами и&nbsp;научными организациями в&nbsp;Арктическом регионе является сетевое сотрудничество, реализация совместных международных научно-образовательных проектов, образовательных программ и&nbsp;курсов, международная академическая мобильность, организация международных конференций и&nbsp;семинаров, совместные научные экспедиции.</p><p>В&nbsp;САФУ проходят обучение более 450 иностранных студентов из&nbsp;45&nbsp;стран мира. Реализуется 9&nbsp;международных образовательных программ уровня бакалавриата и&nbsp;магистратуры по&nbsp;приоритетным направлениям развития Арктики, 48&nbsp;учебных курсов на&nbsp;английском языке, разработаны и&nbsp;пользуются популярностью у&nbsp;иностранных студентов семестровые образовательные программы.</p><p>САФУ является серьезной международной дискуссионной площадкой для обсуждения вопросов развития Арктики. За&nbsp;2014 года состоялось более 95&nbsp;международных мероприятий с&nbsp;участием более 500&nbsp;партнеров. </p>',
          icons: ['registry'],
        },
        {
          id: 'sfu',
          title: 'Сибирский федеральный университет, СФУ',
          site: 'http://www.sfu-kras.ru/',
          desc: '<p>Миссия университета – создание передовой образовательной, научно-исследовательской и инновационной инфраструктуры, продвижение новых знаний и технологий для решения задач социально-экономического развития Сибирского федерального округа, а также формирование кадрового потенциала&nbsp;– конкурентоспособных специалистов по приоритетным направлениям развития Сибири и Российской Федерации, соответствующих современным интеллектуальным требованиям и отвечающих мировым стандартам.</p><p>Стратегическая цель – развитие интеллектуального капитала и опережающего наукоемкого образования, обеспечивающее устойчивое повышение качества жизни населения Сибири на основе подготовки высококвалифицированных кадров, способных к творческой и практической деятельности, генерации глобально значимых знаний и технологий, направленных на расширение экономического потенциала и мировой конкурентоспособности приоритетных отраслей региональной экономики Сибирского федерального округа.</p>',
          icons: ['storage', 'registry'],
        },
        {
          id: 'tsu',
          title: 'Томский Государственный Университет',
          site: 'https://tsu.ru/',
          desc: '<p>Национальный исследовательский Томский государственный университет как университет исследовательского типа видит свою миссию в сохранении и приумножении духовных ценностей человечества, в получении и распространении передовых знаний и информации, в опережающей подготовке интеллектуальной элиты общества на основе интеграции учебного процесса, фундаментальных научных исследований и инновационных подходов.</p>',
          icons: ['storage', 'registry'],
        },
      ],
    };
  },

  methods: {

    tooltip(el) {
      if (el.icons.indexOf('storage') > -1 && el.icons.indexOf('registry') > -1) {
        return 'Хранилище и распределенный реестр.';
      }
      if (el.icons.indexOf('storage') > -1) {
        return 'Хранилище.';
      }
      return 'Распределенный реестр.';
    },

    showDialog(item) {
      this.curItem = item;
      this.dialogVisible = true;
    },

  },

};
</script>

<style lang="scss">
@import '../../styles/common/main';
.aor_items {
  @include clearfix;
  padding: 15px 0 0;
  .aor_item {
    position: relative;
    @include clearfix;
    margin: 15px 0;
    width: 20%;
    padding: 0 40px 0 0;
    float: left;
    &:hover .aor_image {
      opacity: .6;
    }
    @media (max-width: 1080px) {
      width: 25%;
      padding-right: 30px;
      margin: 10px 0;
    }
    @media (max-width: 880px) {
      width: 33.3333333%;
      margin: 5px 0;
    }
    @media (max-width: 550px) {
      width: 50%;
    }
    .aor_hex {
      width: 100%;
      height: auto;
      cursor: pointer;
    }
    .aor_image {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;
      margin-left: -28%;
      transform: translateY(-58%);
      width: 40%;
      height: auto;
      display: inline-block;
      cursor: pointer;
      transition: opacity .3s;
    }
    .aor_icons {
      position: absolute;
      top: 10%;
      right: 10%;
      width: 29%;
      height: 30%;
      border-radius: 50%;
      background-color: #fff;
      padding-top: 10%;
      text-align: center;
      cursor: help;
      img {
        width: 30%;
        height: auto;
        margin: 0 4%;
        display: inline-block;
      }
      @media (max-width: 350px) {
        padding-top: 7%;
      }
    }
  }
  .aoi_dialog_apd {
    .apd_desc {
      padding-left: 55px;
      position: relative;
      .apd_icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 42px;
        height: auto;
      }
      .apd_number-link {
        margin: 15px 0 0;
        .apd_number {
          display: inline-block;
          background-color: #a95e7f;
          color: #fff;
          padding: 4px 12px 1px;
          border-radius: 15px;
          margin: 0 5px;
          font-size: 13px;
        }
      }
    }
  }
}
.theme-w {
  .aor_icons {
    box-shadow: 0 4px 15px rgba(0, 0, 0, .08);
  }
}
.aor_dialog_aod {
  .el-dialog {
    max-width: 800px;
  }
  .aod_desc {
    .aod_title {
      font-size: 24px;
      line-height: 28px;
      color: #f4466f;
      margin-bottom: 20px;
      transition: opacity .3s;
      &:hover {
        opacity: .7;
      }
    }
    .aod_image {
      display: block;
      float: left;
      width: 130px;
      margin: 0 15px 10px 0;
      height: auto;
      @media (max-width: 450px) {
        margin: 35px auto;
        float: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AboutOrganizations.vue